import React, {useState} from 'react';
import '../App.css';
import map from "../static/img/map.jpg";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import euroUnionFlag from "../static/img/EuroUionFlag.png";
import pdfFile from "../static/file/GrantAgreement.pdf";
import pdfUkrFile from "../static/file/GrantAgreementUkr.pdf";
import {Link} from "react-router-dom";

function Home() {
    const [show, setShow]= useState({show1:false, show2:false, show3:false});
    const [isHovered, setIsHovered] = useState({on:false,index:0});
    const [en, setEn] = useState(false);
    return (
        <div className="Home">
            <header className="Home-header">
                <div className={"banner"} style={{color:"white"}} >
                    {en ? <h1>
                       DOMANI - Developing Micro-credentials Ecosystems in Ukraine and Mongolia for Competitive and Resilient Green Economies
                    </h1>
                    : <h1>
                        DOMANI - Розвиток мікро-кредитних екосистем в Україні та Монголії для конкурентоспроможної та стійкої зеленої економіки
                    </h1>}
                </div>
                {en ? <h1>
                    DOMANI - Developing Micro-credentials Ecosystems in Ukraine and Mongolia for Competitive and Resilient Green Economies
                </h1>
                : <h1>
                    DOMANI - Розвиток мікро-кредитних екосистем в Україні та Монголії для конкурентоспроможної та стійкої зеленої економіки
                </h1>}

                <div style={{display:"flex",flexDirection:"row"}} >
                    <div style={{display:"flex",flexDirection:"row",marginLeft:"320px"}}>
                        <img style={{width:"105px",height:"70px",marginRight:"8px"}}
                             src={euroUnionFlag} alt="flag"/>
                        <h1 style={{color:"#031f6b"}}>Erasmus+</h1>
                    </div>
                    <button className={"consortium_button"} style={{borderRadius:"50%",height:"80px",marginLeft:"320px"}}
                            onClick={()=> setEn(!en)} >
                        {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                    </button>
                </div>

                <div style={{display:"flex",flexDirection:"row",width:"calc(100% - 50px)",borderBottom:"2px solid grey"}} >
                    <div style={{width:"50%",padding:"0 30px 0 20px",textAlign:"left"}} >
                        {en ? <h3>Topic: ERASMUS-EDU-2024-CBHE-STRAND-2</h3>:
                            <h3>Тема: ERASMUS-EDU-2024-CBHE-STRAND-2</h3>}
                        {en ? <div style={{fontWeight:"bold",fontSize:"24px"}} >
                            Project website : <a href="https://domaniproject.eu">https://domaniproject.eu</a>
                        </div> :
                        <div style={{fontWeight:"bold",fontSize:"24px"}} >
                            Сайт проєкту : <a href="https://domaniproject.eu">https://domaniproject.eu</a>
                        </div>}

                        {en ? <p>Project number: 101179859</p> : <p>Проєкт № 101179859</p>}

                        {en ? <p>Project duration: 36 months (01.11.2024 – 31.10.2027)</p> :
                            <p>Тривалість проєкту: 36 months (01.11.2024 – 31.10.2027)</p>}

                        {/*<img src="https://ecology.karazin.ua/wp-content/uploads/2019/09/v4ukraine_full_1-800x226.png" alt="map"/>*/}
                        <img src={map} style={{width:"800px", height:"226px"}} alt="map"/>
                    </div>

                    <div style={{width:"50%"}} >
                        <ul style={{listStyle:"none"}}>
                            <li style={{marginBottom:"20px"}} >
                                <button className={"btn"} onClick={()=>setShow({show1:!show.show1,show2:false,show3:false})}
                                        style={show.show1 ? {backgroundColor:"#3db166",color:"white"} : {backgroundColor:"#eee"}}
                                >
                                    {en ? `ABOUT PROJECT` : `Про проект`}
                                </button>
                                {show.show1 && <div className={"underline"} >

                                    <Link to={"shortDescription"} id={"shortDescription"}
                                          style={(isHovered.on && isHovered.index === 10) ? {color:"#3db166"} : {color:"#363636"}}
                                          onMouseEnter={() => setIsHovered({on:true,index:10})}
                                          onMouseLeave={() => setIsHovered({on:false,index:10})}
                                    >
                                        {en ? `Brief description of the project` : `Короткий опис проекту`}
                                    </Link><br/>
                                    <Link to={"consortium"} id={"consortium"}
                                          style={(isHovered.on && isHovered.index === 11) ? {color:"#3db166"} : {color:"#363636"}}
                                          onMouseEnter={() => setIsHovered({on:true,index:11})}
                                          onMouseLeave={() => setIsHovered({on:false,index:11})}
                                    >
                                        {en ? `Consortium` : `Консорціум`}
                                    </Link><br/>
                                    {en ? <a href={pdfFile} target="_blank" rel="noopener noreferrer" id={"grant"}
                                          style={(isHovered.on && isHovered.index === 12) ? {color:"#3db166"} : {color:"#363636"}}
                                          onMouseEnter={() => setIsHovered({on:true,index:12})}
                                          onMouseLeave={() => setIsHovered({on:false,index:12})}
                                    >
                                        GRANT AGREEMENT
                                    </a> :
                                    <a href={pdfUkrFile} target="_blank" rel="noopener noreferrer" id={"grant"}
                                       style={(isHovered.on && isHovered.index === 12) ? {color:"#3db166"} : {color:"#363636"}}
                                       onMouseEnter={() => setIsHovered({on:true,index:12})}
                                       onMouseLeave={() => setIsHovered({on:false,index:12})}
                                    >
                                        ГРАНТОВА УГОДА
                                    </a>}

                                </div>}
                            </li>
                            <li style={{marginBottom:"20px"}} >
                                <button className={"btn"} onClick={()=>setShow({show1:false,show2:!show.show2,show3:false})}
                                        style={show.show2 ? {backgroundColor:"#3db166",color:"white"} : {backgroundColor:"#eee"}}
                                >{en ? `Teachers` : `Викладачі`}
                                </button>
                                {show.show2 && <div className={"underline"} >
                                    <Link to={"coordinator"} id={"coordinator"}
                                          style={(isHovered.on && isHovered.index === 0) ? {color:"#3db166"} : {color:"#363636"}}
                                          onMouseEnter={() => setIsHovered({on:true,index:0})}
                                          onMouseLeave={() => setIsHovered({on:false,index:0})}
                                    >
                                        {en ? `Course coordinator` : `Координатор курсу`}
                                    </Link><br/>
                                    <Link to={"authors"} id={"authors"}
                                          style={(isHovered.on && isHovered.index === 0) ? {color:"#3db166"} : {color:"#363636"}}
                                          onMouseEnter={() => setIsHovered({on:true,index:0})}
                                          onMouseLeave={() => setIsHovered({on:false,index:0})}
                                    >
                                        {en ? `Program authors` : `Автори програм`}
                                    </Link>
                                </div>}
                            </li>
                            <li>
                                <button className={"btn"} onClick={()=>setShow({show1:false,show2:false,show3:!show.show3})}
                                        style={show.show3 ? {backgroundColor:"#3db166",color:"white"} : {backgroundColor:"#eee"}}
                                >{ en ? `Teaching` : `Навчання`}
                                </button>
                                {show.show3 && <div className={"underline"} >
                                    <Link to={"microcredit"} id={"microcredit"}
                                          style={(isHovered.on && isHovered.index === 0) ? {color:"#3db166"} : {color:"#363636"}}
                                          onMouseEnter={() => setIsHovered({on:true,index:0})}
                                          onMouseLeave={() => setIsHovered({on:false,index:0})}
                                    >
                                        {en ? `List of microcredit programs` : `Перелік мікрокредитних програм`}
                                    </Link>
                                </div>}
                            </li>
                        </ul>

                    </div>
                </div>
                <div>
                    {en ? <h2>
                        NEWS
                    </h2> :
                    <h2>
                        Новини проекту
                    </h2>}
                    <ul style={{marginLeft:"-560px"}}> {/*listStyle:"none",*/}
                        <li className={"li_refer"} >
                            <Link to={"onlineMeeting"} id={"onlineMeeting"}
                                  style={(isHovered.on && isHovered.index === 0) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:0})}
                                  onMouseLeave={() => setIsHovered({on:false,index:0})}
                            >
                                {en ? `Online meeting` : `Онлайн-зустріч`}
                            </Link>
                            <p>27.11.2024</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"survey"} id={"survey"}
                                  style={(isHovered.on && isHovered.index === 1) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:1})}
                                  onMouseLeave={() => setIsHovered({on:false,index:1})}
                            >
                                {en ? `Survey` : `Опитування`}
                            </Link>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"workingMeeting"} id={"workingMeeting"}
                                  style={(isHovered.on && isHovered.index === 2) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:2})}
                                  onMouseLeave={() => setIsHovered({on:false,index:2})}
                            >
                                {en ? `Working meeting under the Erasmus+ DOMANI project` : `Робоча зустріч за проєктом Ерасмус+ DOMANI`}
                            </Link>
                            <p>28-31.01.2025</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"onlineTraining"} id={"onlineTraining"}
                                  style={(isHovered.on && isHovered.index === 3) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:3})}
                                  onMouseLeave={() => setIsHovered({on:false,index:3})}
                            >
                                {en ? `Online training` : `Онлайн-тренінг`}
                            </Link>
                            <p>28-29.05.2025</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"podilskieReadings"} id={"podilskieReadings"}
                                  style={(isHovered.on && isHovered.index === 4) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:4})}
                                  onMouseLeave={() => setIsHovered({on:false,index:4})}
                            >
                                {en ? `Presentation of the DOMANI project at the conference PODILSKIE READINGS – 2025 (Ukraine)` :
                                    `Презентація проєкту ДОМАНІ на конференції ПОДІЛЬСЬКІ ЧИТАННЯ – 2025 (Україна)`}
                            </Link>
                            <p>6.11.2025</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"onlineNextMeeting"} id={"onlineNextMeeting"}
                                  style={(isHovered.on && isHovered.index === 5) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:5})}
                                  onMouseLeave={() => setIsHovered({on:false,index:5})}
                            >
                                {en ? `Online meeting` :
                                    `Онлайн-зустріч`}
                            </Link>
                            <p>17.12.2025</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"onlineTraining2026"} id={"onlineTraining2026"}
                                  style={(isHovered.on && isHovered.index === 6) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:6})}
                                  onMouseLeave={() => setIsHovered({on:false,index:6})}
                            >
                                {en ? `Online training` : `Онлайн-тренінг`}
                            </Link>
                            <p>29.01.2026</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"hackathonTraining"} id={"hackathonTraining"}
                                  style={(isHovered.on && isHovered.index === 7) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:7})}
                                  onMouseLeave={() => setIsHovered({on:false,index:7})}
                            >
                                {en ? `UA Hackathon Training DOMANI` : `Тренінг з організації онлайн-хакатонів`}
                            </Link>
                            <p>4.03.2026</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"hackathonInOdesa"} id={"hackathonInOdesa"}
                                  style={(isHovered.on && isHovered.index === 8) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:8})}
                                  onMouseLeave={() => setIsHovered({on:false,index:8})}
                            >
                                {en ? `Students from Karazin University at the FRESH AIR 2026 Hackathon in Odesa ` :
                                    `Студенти Каразінського університету на Хакатоні FRESH AIR 2026 в Одесі `}
                            </Link>
                            <p>2-4.04.2026</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"erasmusDays"} id={"erasmusDays"}
                                  style={(isHovered.on && isHovered.index === 9) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:9})}
                                  onMouseLeave={() => setIsHovered({on:false,index:9})}
                            >
                                {en ? `ERASMUSDAYS-2026 ` :
                                    `ERASMUSDAYS-2026 `}
                            </Link>
                            <p>14.10.2026</p>
                        </li>
                        <li className={"li_refer"} >
                            <Link to={"onlineWorkshop"} id={"onlineWorkshop"}
                                  style={(isHovered.on && isHovered.index === 10) ? {color:"#3db166"} : {color:"#363636"}}
                                  onMouseEnter={() => setIsHovered({on:true,index:10})}
                                  onMouseLeave={() => setIsHovered({on:false,index:10})}
                            >
                                {en ? `Online workshop` : `Онлайн-семінар`}
                            </Link>
                            <p>29.10.2026</p>
                        </li>
                    </ul>
                </div>
                <div style={{width:"calc(100% - 50px)",height:"120px",backgroundColor:"#363636",paddingLeft:"50px",display:"flex",alignItems:"center"}} >
                    <p style={{color:"white",textAlign:"left"}} >
                        {en ? `© 2007-2025 Karazin Educational and Scientific Institute of Ecology` : `© 2007-2026 Каразінський навчально-науковий інститут екології`}
                    </p>
                </div>
            </header>
        </div>
    );
}

export default Home;
